// extracted by mini-css-extract-plugin
export default {"skipLinkList":"skipLink_skipLinkList__VosSN","skipLink":"skipLink_skipLink__zZbWt"};